import { unwrap, type PortalOrganisationContext } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';

export type OrganisationResponse = PortalOrganisationContext;

export const getCurrentOrganisation = async (
  signal?: AbortSignal
): Promise<OrganisationResponse> => {
  return unwrap(await api.portalGateway.GET('/portal/v1/context', { signal }));
};
